module.exports = __webpack_public_path__ + "static/joeexotic-d838fde34e053547da3897621552fe5d.png";